import { CommentQuestionOutlineIcon } from './CommentQuestionOutlineIcon';

/**
 * author: Simran
 * id 7BD335A6-C4A7-48F1-B04F-F1457B7B1F20
 * name comment-question-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-question-outline.svg
 * tags
 */
export const CommentHelpOutlineIcon = CommentQuestionOutlineIcon;
export default CommentHelpOutlineIcon